export const renderInputOrSpan = (renderAsSpans, value, classes, type = 'text') => {
    return renderAsSpans ? (
        <span className={classes.styleSpan}>{value}</span>
    ) : (
        <input disabled className={classes.styleInput} type={type} value={value} />
    );
};
export const renderInputOrSpanForButton = (renderAsSpans, value, classes, type = 'text') => {
    return renderAsSpans ? (
        <span className={classes.styleSpan} style={{ marginRight: '50px' }}>{value}</span>
    ) : (
        <input disabled className={classes.styleInput} type={type} value={value} />
    );
};
export const getLabelClass = (renderAsSpans, classes) => {
    return renderAsSpans ? classes.styleSpanLabel : classes.labelInput;
};